import { render, staticRenderFns } from "./ProductDescription.vue?vue&type=template&id=4fb6732a&"
import script from "./ProductDescription.vue?vue&type=script&lang=ts&"
export * from "./ProductDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports